<template>
  <div :class="$style.page">
    <div :class="$style.title">Whois 查询</div>
    <div :class="$style.searchBox">
      <el-input
        v-model.trim="search"
        clearable
        placeholder="请输入域名信息"
        maxlength="30"
        @on-keyup="change"
        @on-enter="searchEvnet"
      />

      <div :class="$style.searchBtn" @click="searchEvnet">查询</div>
    </div>
    <Loading :loading="loadings" text="">
    <div v-if="!noData && !noResult" :class="$style.whoisContent">

      <div :class="$style.whoisTop">
        <div :class="$style.whiosTitle">
          域名
          <span style="font-size: 30px; font-weight: bold; color: #333">{{
            info.name
          }}</span>
          注册信息
          <span style="float: right; cursor: pointer" @click="refreshWhois">获取最新信息</span>
        </div>
        <div style="margin-top: 16px">
          <div :class="$style.infoItem" style="margin-top: 16px">
            <div :class="$style.infoTitle">域名:</div>
            <div :class="$style.infoText">{{ info.name }}</div>
          </div>
          <div :class="$style.infoItem">
            <div :class="$style.infoTitle">域名状态:</div>
            <div :class="$style.infoText">
              <p v-for="item in info.status" :key="item">
                {{ item }}
              </p>
            </div>
          </div>
          <div :class="$style.infoItem">
            <div :class="$style.infoTitle">注册联系电话:</div>
            <div :class="$style.infoText">{{ info.telphone }}</div>
          </div>
          <div :class="$style.infoItem">
            <div :class="$style.infoTitle">注册者联系电子邮箱:</div>
            <div :class="$style.infoText">{{ info.mail }}</div>
          </div>
          <div :class="$style.infoItem">
            <div :class="$style.infoTitle">注册商:</div>
            <div :class="$style.infoText">{{ info.registrar }}</div>
          </div>
          <div :class="$style.infoItem">
            <div :class="$style.infoTitle">DNS服务器:</div>
            <div :class="$style.infoText">
              <p v-for="(item, index) in info.dns" :key="item">
                DNS{{ index + 1 }}：{{ item }}
              </p>
              <p v-if="info.dns.length === 0">暂无数据</p>
            </div>
          </div>
          <div :class="$style.infoItem">
            <div :class="$style.infoTitle">注册日期:</div>
            <div :class="$style.infoText">{{ info.registerTime }}</div>
          </div>
          <div :class="$style.infoItem">
            <div :class="$style.infoTitle">过期时间:</div>
            <div :class="$style.infoText">{{ info.expirationTime }}</div>
          </div>
        </div>
      </div>
      <div :class="$style.whoisBottom">
        <div :class="$style.engTitle">
          <span :class="$style.titleInner">详细英文注册信息</span>
        </div>
        <div :class="$style.content" v-html="info.details || ''"></div>
      </div>
    </div>
    <div v-if="noData" :class="$style.whoisContent">
      <span class="c-o">“{{ search }}”</span>未查询到whois信息<span
        style="color: #576cca; margin-left: 5px; cursor: pointer"
        @click="toRegister(search)"
      >
        >> 立即注册</span
      >
    </div>

    <div v-if="noResult" :class="$style.whoisContent">
      <div style="font-size: 20px; color: #333">未查询到whois信息</div>
      <div style="font-size: 14px; color: #333; margin-top: 10px">
        该域名可能被注册局保留、正在审核或限制注册，暂无whois信息
      </div>
    </div>
    </Loading >
    <captcha ref="childCaptcha" @custom-event="getCodeEvent"></captcha>
  </div>
</template>


<script>
import { getCaptchaWhoisV1, getCaptchaWhoisV2 } from "@server";
import Captcha from "@components/Captcha.vue";
const domain =
  // eslint-disable-next-line max-len
  /[^.]+\.(top|com.cn|com|cn|xyz|club|中国|网址|work|vip|beer|在线|net.cn|tv|org.cn|org|name|cc|中文网|info|pro|red|网店|net|yoga|fashion|luxe|love|kim|blue|pet|pink|移动|ski|ltd|chat|group|pub|run|city|live|ink|wiki|design|email|company|plus|video|center|cool|fund|gold|guru|life|show|team|today|world|zone|social|网站|bio|black|green|lotto|organic|poker|promo|vote|archi|voto|online|site|store|tech|fun|space|host|press|wang|商店|企业|娱乐|游戏|fit|icu|art|website|asia|我爱你|集团|biz|games|tax|studio|shopping|media|cash|fyi|vin|sale|mba|band|cab|fan|news|cafe|technology|market|fans|ren|cloud|co|shop|law|link|ac.cn|bj.cn|tj.cn|sh.cn|cq.cn|he.cn|ha.cn|sx.cn|nm.cn|ln.cn|jl.cn|hl.cn|js.cn|zj.cn|ah.cn|fj.cn|jx.cn|sd.cn|hb.cn|hn.cn|gd.cn|gx.cn|hi.cn|sc.cn|gz.cn|yn.cn|xz.cn|sn.cn|gs.cn|qh.cn|nx.cn|xj.cn|tw.cn|hk.cn|mo.cn)/;
export default {
  components: {
    Captcha
  },
  data() {
    return {
      showNav: false,
      loadings: false,
      search: "",
      info: {
        details: "",
        dns: [],
        name: "",
        contactMail: "",
        endDateTime: "",
        contactPhone: "",
        registrar: "",
        registrationTime: "",
        status: [],
      },

      // 没有数据
      noData: false,
      // 没有结果
      noResult: false,
    };
  },
  mounted() {
    this.search = this.$route.query.key.toLowerCase() || "";
    if (!this.search) {
      this.$Message.warning("请输入查询的域名信息！");
      this.loadings = false;
      return false;
    }
    // 获取最后一个带点的数据
    const temp = this.search.match(domain);
    if (temp && temp.length > 0) {
      this.search = temp[0];
    } else {
      this.$Message.warning("请输入正确域名信息！");
      return false;
    }
    this.init();
  },
  methods: {
    refreshWhois() {
      this.$refs.childCaptcha.onShow()
    },
    async getCodeEvent(obj) {
      try {
        this.loadings = true;
        const { code, data } = await getCaptchaWhoisV2(this.search, obj.id, obj.code);

        this.loadings = false;
        if (code === 200) {
          this.info = data;
          this.info.details = data.details.replace(/\n/g, "<br/>");
          if (this.info.status) {
            this.info.status = data.status.split(",");
          } else {
            this.info.status = [];
          }

          if (this.info.dns) {
            this.info.dns = data.dns.split(",");
          } else {
            this.info.dns = [];
          }

          this.noData = data.lable === 0;
          this.noResult = data.lable === 2;
        } else {
          this.noData = true;
          this.noResult = false;
        }
      } catch (error) {
        this.loadings = false;
        this.$Message.warning(error);
      }
    },
    change() {
      this.search = this.search.replace(/\s+/g, "");
    },
    // 初始化
    async init() {
      try {
        this.loadings = true;
        const { code, data } = await getCaptchaWhoisV1(this.search);

        this.loadings = false;
        if (code === 200) {
          this.info = data;
          this.info.details = data.details.replace(/\n/g, "<br/>");
          if (this.info.status) {
            this.info.status = data.status.split(",");
          } else {
            this.info.status = [];
          }

          if (this.info.dns) {
            this.info.dns = data.dns.split(",");
          } else {
            this.info.dns = [];
          }

          this.noData = data.lable === 0;
          this.noResult = data.lable === 2;
        } else {
          this.noData = true;
          this.noResult = false;
        }
      } catch (error) {
        this.loadings = false;
        this.$Message.warning(error);
      }
    },
    // 搜索
    searchEvnet() {
      if (!this.search) {
        this.$Message.warning("请输入查询的域名信息！");
        return false;
      }
      // 获取最后一个带点的数据
      const temp = this.search.match(domain);
      if (temp && temp.length > 0) {
        this.search = temp[0];
      } else {
        this.$Message.warning("请输入正确域名信息！");
        return false;
      }
      this.$nextTick(() => {
        history.pushState("", "", `/whois?key=${this.search}`);
        this.init();
      });
    },
    toRegister(name) {
      let newName = name.substring(0, name.indexOf("."));
      window.open(`/dSearch?name=${newName}`, "_blank");
    },
  },
};
</script>


<style lang="scss" module scoped>
.page {
  width: rem(1200);
  margin: rem(80) auto rem(100);
  .title {
    font-size: 24px;
    font-weight: bold;
    color: #333333;
  }
  .searchBox {
    display: flex;
    margin-top: 40px;
    .searchBtn {
      width: 160px;
      height: 38px;
      background: #ff5c35;
      color: #fff;
      line-height: 38px;
      text-align: center;
      cursor: pointer;
    }
    ::v-deep .el-input {
      width: rem(430);
      .el-input__inner &:hover {
        border: 1px solid #dcdfe6;
      }
    }
  }
  .whoisContent {
    margin-top: 24px;
    padding: 20px 38px;
    background: #fff;
    color: #333;
    .whoisTop {
      .whiosTitle {
        padding-bottom: 20px;
        border-bottom: 1px solid #eeeeee;
      }
      .infoItem {
        display: flex;
        line-height: 36px;
        .infoTitle {
          text-align: right;
          font-size: 14px;
          color: #777;
          min-width: 130px;
        }
        .infoText {
          color: #555;
          font-size: 14px;
          margin-left: 16px;
        }
      }
    }
    .whoisBottom {
      margin-top: 48px;
      color: #333;
      font-weight: bold;
      padding-bottom: 20px;
      border-bottom: 1px solid #eeeeee;
      .titleInner {
        padding-bottom: 20px;
        border-bottom: 3px solid #ff5c35;
      }
      .content {
        font-weight: 500;
        margin-top: 50px;
        color: #666;
        line-height: 28px;
      }
    }
  }
}
</style>
